import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'

import ExpenseAddForm from './add-form.js'

export default {
  name: 'MiscellaneousExpenseAdd',
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      data: null,
      form: ExpenseAddForm
    }
  },
  components: {
    AutocompleteZ
  },
  created () {
    this.onLoadAllSections()
  },
  methods: {
    onLoad () { },
    onCreate () {
      loading.push()
      /*
      GroupRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
        */
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.form.secaoRHID.options = this.onResultDropdown(response, null, f => f.codigo + ' - ' + f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    onChangeCodeSection (value) {
      var options = this.form.secaoRHID.options
      this.form.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.form.secaoRHID.value = options[i].value
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/add/add.js